import React from "react";

// Mui
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";

// Mui Styles
import DateSelection from "@/components/dateSelection";
import CheckInDialog from "@/components/Dialog/checkInDialog";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Navigate
import { useLocation } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
// import StaffCard from "@/components/staffCard";
import DataTable from "@/components/dataTable";

// Fetch
import { getRosterByDateRange, upsertRosterByUser } from "@/fetch/fetchRoster";
// Moment
import { useCurrentAction } from "@/hooks/user";
import moment from "moment";
import "moment/locale/zh-hk";
import { useSelector } from "react-redux";

// Config
import { checkInRecordTableColumn } from "@/config/tableColumnConfig";

const CheckinPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });

  // Navigate
  const defaultStartDate = moment();
  const defaultEndDate = moment();
  const [isDialogOpen, setDialogOpen] = React.useState(false);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [selectedRoster, setSelectedRoster] = React.useState({});
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const location = useLocation();
  const { pathname } = location;
  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );
  const [checkInRecord, setCheckInRecord] = React.useState([]);

  const onCellClick = (data) => {
    console.log("data", data);
    setSelectedRoster(data.row);
    setDialogOpen(true);
  };

  const getRowId = (row) => {
    return row.roster_id;
  };

  //Fetch all
  const fetchAll = async () => {
    setDataTableLoading(true);
    const { data } = await getRosterByDateRange(
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD")
    );
    setDataTableLoading(false);
    setCheckInRecord(data);
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });

  return (
    <Layout
      header="CheckinPage"
      selectedIndex={3}
      open={open}
      setOpen={setOpen}
      snackClose={() => setSnackOpen(false)}
      snackSeverity={snackSeverity}
      snackMessage={snackMessage}
      snackOpen={snackOpen}
    >
      <Title title="上班紀錄" />
      <StyledPaper page={"yes"} alignItems={"left"}>
        <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
            <DateSelection
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
            ></DateSelection>
          </Grid>
        </ThemeProvider>
      </StyledPaper>
      {isDialogOpen && (
        <CheckInDialog
          open={isDialogOpen}
          actions={actions}
          roster={selectedRoster}
          handleOnChange={(value, field) => {
            const date = moment(selectedRoster.date);
            setSelectedRoster((prev) => ({
              ...prev,
              [field]: moment(value)
                .date(date.date())
                .month(date.month())
                .year(date.year())
                .second(0),
            }));
          }}
          onSubmit={async () => {
            try {
              const payload = [
                {
                  date: moment(selectedRoster.date).format("YYYY-MM-DD"),
                  user_id: selectedRoster.user_id,
                  time_checkedin: selectedRoster.time_checkedin
                    ? moment(selectedRoster.time_checkedin).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    : null,
                  time_checkedout: selectedRoster.time_checkedout
                    ? moment(selectedRoster.time_checkedout).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    : null,
                  is_off: selectedRoster.is_off,
                  is_leave: selectedRoster.is_leave,
                  leave_type: selectedRoster.leave_type,
                  location_id: selectedRoster.location_id,
                  roster: selectedRoster.roster_value,
                  street: selectedRoster.street,
                  start_time: selectedRoster.start_time,
                  end_time: selectedRoster.end_time,
                  lunch: selectedRoster.lunch,
                  remark: selectedRoster.remark,
                },
              ];
              setSnackSeverity("success");
              setSnackMessage("更新成功");
              setSnackOpen(true);
              await upsertRosterByUser(payload);
            } catch (err) {
              setSnackSeverity("errro");
              setSnackMessage(`更新失敗\n${err.message}`);
              setSnackOpen(true);
            } finally {
              setDialogOpen(false);
              fetchAll();
            }
          }}
          onCancel={() => setDialogOpen(false)}
        />
      )}

      <Fade in={true} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={TableListTheme}>
            <DataTable
              loading={dataTableLoading}
              rows={checkInRecord}
              columns={checkInRecordTableColumn}
              checkboxSelection={false}
              pageSize={100}
              onCellClick={(data) => onCellClick(data)}
              getRowId={getRowId}
              initialState={{
                sorting: {
                  sortModel: [{ field: "staff_code", sort: "asc" }],
                },
              }}
            />
          </ThemeProvider>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default CheckinPage;
